import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import {
  getTestData,
  downloadTestData
} from "store/state/calculators/testHarness";
import { TableHead, TableBody, TableRow, TableFooter, TablePagination } from "@material-ui/core";

import shortid from "shortid";
import { MARKET_EXPECTATIONS_SHOCK } from "../../Constants/Constants";
import {
  StyledTable,
  StyledHeaderCell,
  StyledTableCell,
  StyledTableRow, 
  StyledTableDataRow
} from "../../Constants/StyledComponents";
import numberFormatter from 'utils/numberFormatter';
import TablePaginationHelper from "../../../../utils/tablePaginationHelper";

class ResultTable extends Component {
  tablePaginationHelper = new TablePaginationHelper("618718d6-f229-4f51-acd1-9b847032895f");

  createStyledHeaderCell = () => {
    const x = <StyledHeaderCell>Date</StyledHeaderCell>;
    const y = <StyledHeaderCell>Value</StyledHeaderCell>;
    const z = <StyledHeaderCell>Shocked Value</StyledHeaderCell>;

    if (this.props.state.shockType === MARKET_EXPECTATIONS_SHOCK) {
      return [x, y];
    }
    return [x, y, z];
  };

  createStyledTableCell = item => {
    const date = <StyledTableCell>{item.date}</StyledTableCell>;
    const value = <StyledTableCell>{numberFormatter.formatRate(item.value)}</StyledTableCell>;

    if (this.props.state.shock === MARKET_EXPECTATIONS_SHOCK) {
      return [date, value];
    }

    const shockedValue = (
      <StyledTableCell>
        {item.shockedValue ? numberFormatter.formatRate(item.shockedValue) : ""}
      </StyledTableCell>
    );
    return [date, value, shockedValue];
  };

  mapTableData = testData => {
    if (testData) {
      return testData.PagedList.map(item => (
        <StyledTableRow key={shortid.generate()} hover>
          {this.createStyledTableCell(item)}
        </StyledTableRow>
      ));
    }
    return (
      <StyledTableRow key={shortid.generate()} hover>
        <StyledTableCell />
        <StyledTableCell />
      </StyledTableRow>
    );
  };

  render() {
    const {
      testHarness: { testData, records },
      count
    } = this.props;

    if (!testData || !testData.PagedList) return null;

    const rowsPerPage = this.tablePaginationHelper.rowsPerPage;
    const page = this.tablePaginationHelper.page;

    return (
      <Fragment>
        <StyledTable height={20} className="testHarnessTable tableBlueHover">
          <TableHead>
            <StyledTableRow>{this.createStyledHeaderCell()}</StyledTableRow>
          </TableHead>
          <TableBody>{this.mapTableData(testData ? testData : null)}</TableBody>
          <TableFooter>
            <StyledTableDataRow>
              <TablePagination
                colSpan={2}
                count={count}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 1000]}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Previous Page"
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page"
                }}
                onChangePage={this.props.handleChangePage}
                onChangeRowsPerPage={this.props.handleChangeRowsPerPage}
                labelDisplayedRows={() => `${page + 1} of ${Math.ceil(count / rowsPerPage)}`}
              />
            </StyledTableDataRow>
          </TableFooter>
        </StyledTable>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ testHarness }) => ({
  testHarness,
  count:
    testHarness && testHarness.testData && testHarness.testData.ListCount
      ? testHarness.testData.ListCount
      : 1
});

export default compose(
  connect(
    mapStateToProps,
    { getTestData, downloadTestData }
  )
)(ResultTable);
